import { Button } from "@mui/material";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import { Toast } from "../../../../components/Toast";

const ClearSecretsCacheButton = () => {
  const colors = useColors();
  const { clearSecretsCache } = useAPI();

  const handleOnClick = () => {
    clearSecretsCache()
      .then(() => {
        Toast.success("Secrets cache cleared");
      })
      .catch(() => {
        Toast.error("Failed to clear secrets cache");
      });
  };

  return (
    <>
      <CustomToolTip title="Clear the secrets cache on the backend">
        <Button
          variant="outlined"
          sx={{
            backgroundColor: colors.error_main,
            color: colors.contrast_text_light,
            "&:hover": {
              backgroundColor: colors.error_dark,
            },
          }}
          onClick={handleOnClick}
        >
          Clear Secrets Cache
        </Button>
      </CustomToolTip>
    </>
  );
};

export default ClearSecretsCacheButton;
